import './HeaderWithButtonMenu.scss';
import { isArray } from 'lodash';
import ResizeObserver from 'rc-resize-observer';
import { Col, Dropdown, Row, Space } from 'antd';
import React, { useCallback, useLayoutEffect, useMemo, useRef, useState } from 'react';
const gapSize = 8;
export const HeaderWithButtonMenu = ({ children, title }) => {
    const [overflowCount, setOverflowCount] = useState(0);
    const buttonWidths = useRef(null);
    const lastRowWidth = useRef();
    const rowRef = useRef(null);
    const titleRef = useRef(null);
    const buttonsRef = useRef(null);
    const buttons = useMemo(() => {
        if (!children) {
            return [];
        }
        if (!isArray(children)) {
            return [children];
        }
        return children.filter((entry) => Boolean(entry));
    }, [children]);
    const recalcOverflow = useCallback(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!buttonWidths.current || buttonWidths.current.length <= 1) {
            setOverflowCount(0);
            return;
        }
        const rowWidth = (_b = (_a = rowRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 0;
        const titleWidth = (_d = (_c = titleRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().width) !== null && _d !== void 0 ? _d : 0;
        const buttonsWidth = (_f = (_e = buttonsRef.current) === null || _e === void 0 ? void 0 : _e.getBoundingClientRect().width) !== null && _f !== void 0 ? _f : 0;
        if (lastRowWidth.current === rowWidth) {
            return;
        }
        lastRowWidth.current = rowWidth;
        let overflow = titleWidth + buttonsWidth - rowWidth + gapSize;
        if (overflow > 0) {
            let buttonIndex = 0;
            while (overflow > 0) {
                overflow -= (_h = (_g = buttonsRef.current) === null || _g === void 0 ? void 0 : _g.children[buttonIndex].getBoundingClientRect().width) !== null && _h !== void 0 ? _h : 0;
                buttonIndex++;
            }
            setOverflowCount(overflowCount + buttonIndex);
            return;
        }
        if (overflowCount && overflow < 0) {
            let buttonIndex = overflowCount - 1;
            while (overflow < 0 && buttonIndex >= 0) {
                overflow += buttonWidths.current[buttonIndex] + gapSize;
                if (overflow > 0) {
                    break;
                }
                buttonIndex--;
            }
            setOverflowCount(buttonIndex + 1);
        }
    }, [overflowCount]);
    useLayoutEffect(() => {
        var _a, _b;
        if (!buttonWidths.current) {
            const buttonElements = [...(_b = (_a = buttonsRef.current) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : []];
            buttonWidths.current = buttonElements.map((element) => element.getBoundingClientRect().width);
        }
        recalcOverflow();
    }, [recalcOverflow]);
    const managedButtons = useMemo(() => {
        if (!buttonWidths.current || buttons.length <= 1 || !overflowCount) {
            return buttons;
        }
        const rootButton = buttons[buttons.length - 1];
        const menuButtons = buttons.slice(0, overflowCount).reverse();
        const remainingButtons = buttons.slice(overflowCount, -1);
        return (React.createElement(Space, { className: 'button-menu-space collapsed', size: 'small' },
            remainingButtons,
            React.createElement(Dropdown.Button, { buttonsRender: ([, dropdownButton]) => [
                    rootButton,
                    dropdownButton
                ], popupRender: () => React.createElement(Space, { direction: 'vertical', size: 'small' }, menuButtons) })));
    }, [buttons, overflowCount]);
    return (React.createElement(ResizeObserver, { onResize: recalcOverflow },
        React.createElement(Row, { align: 'middle', className: 'button-menu-header', justify: 'space-between', ref: rowRef },
            React.createElement(Col, { ref: titleRef }, title),
            React.createElement(Col, null,
                React.createElement(Space, { className: 'button-menu-space', ref: buttonsRef, size: 'small' }, managedButtons)))));
};
